import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styles from "./styles.scss"

class SearchField extends React.Component {

  /* componentDidUpdate () {
    setTimeout(() => {
      this.textInput.focus() 
    }, 50);
  } */

  render() {
    const { value, onChange } = this.props
    return (
      <div className={styles.container}>
        <input
          ref={(input) => { this.textInput = input; }}
          value={value}
          className={styles.inputField}
          onChange={onChange}
          placeholder="Sök efter kommun..."
        />
        <FontAwesomeIcon icon="search" className={styles.searchIcon} />
      </div>
    )
  }
}

export default SearchField



// WEBPACK FOOTER //
// src/components/SearchBarWrapper/DropdownBox/SearchField/index.jsx